module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getWho()) + "的捐赠动态")]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "tag": "ul",
      "name": "fade"
    }
  }, _vm._l((_vm.donationObjects), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "image"
    }, [_c('webp-image', {
      attrs: {
        "src": item.icon,
        "width": "100%"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.formatDate(item.date)))])], 1), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.getWho()) + "为" + _vm._s(item.name) + "捐赠了 " + _vm._s(_vm.duration2course(item.duration)) + " 节智能课程")])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-1da7d69c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/News.vue
// module id = 201
// module chunks = 0